import { faceMock } from "../../mocks/face";
import { store } from "../../store";
import { NETWORK_WARNINGS_INACTIVE, NETWORK_WARNINGS_ACTIVE, getFetchConfig, urlAddTenant } from ".";
import { delayedPromise } from "../../delayedPromise";

/**
 * POST /{tenant}/IdentityXServices/rest/v1/users/{userId}/face/samples
 */
export const faceSave = (data) => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => {
    controller.abort();
  }, 30000);
  let promise;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(faceMock);
  } else {
    const { application } = store.getState();
    promise = fetch(
      urlAddTenant(
        `/IdentityXServices/rest/v1/users/${application.user.id}/face/samples`
      ),
      {
        ...getFetchConfig(),
        method: "POST",
        credentials: "same-origin",
        signal,
        body: JSON.stringify({ data, format: "jpg" }),
      }
    );
  }
  return promise.then((response) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    return response;
  });
};
